import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  updatePastureContainer: {
    padding: 8,
    width: '100%',
    boxSizing: 'border-box'
  },
  updatePastureButton: {
    marginTop: 21,
    width: 112
  },
  updatePastureButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.app.colors.text.light,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: '#f0e6e3'
    }
  },
  updatePastureInput: {
    width: '100%',
    marginBottom: '8px'
  },
  updatePastureInputCityUf: {
    width: '50%',
    flexGrow: 1
  },
  updatePastureBox: {
    width: '100%',
    flexGrow: 1
  },
  updatePastureButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    '& button': {
      margin: '0 0 0 16px'
    }
  },

  updatePastureDivider: {
    width: '100% !important',
    marginTop: '8px'
  },
  sectionLabel: {
    color: theme.app.colors.text.primary,
    width: '100%',
    fontSize: theme.app.typography.label.fontSize,
    fontWeight: 500,
    marginTop: '8px'
  },

  updatePastureClassificationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
    marginBottom: 16
  },

  modalFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 16,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      '& button': {
        width: '100%'
      }
    }
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',

    minHeight: 200
  }
}))
